import { AppBar, Box, IconButton, Toolbar, Typography, makeStyles } from '@material-ui/core';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Image from '../../../components/atom/image';
import { useSelector } from 'react-redux';
import useInvestorCartDetail from './hooks/useInvestorCartDetail';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    investorNameContainer: {
        flexGrow: 1,
        position: 'relative',
        '&::after': {
            color: "#444",
            border: 0,
            font: "normal normal normal 24px / 1 `Material Design Icons`",
            content: '"\\f107"', // FontAwesome icon Unicode
            fontFamily: 'FontAwesome', // Ensure the correct font-family is used
            width: '12px',
            height: '12px',
            verticalAlign: 'baseline',
            fontSize: '14px',
            position: 'absolute',
            right: '-19px',
            top: '0px',
            [theme.breakpoints.down('xs')]: {
                top: '-9px'
            },
        }
    },
    title: {
        fontSize: '0.875rem',
        color: '#000',
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
    },

    appBarColorPrimaryClass: {
        backgroundColor: '#FFF'
    },
    toolBarRoot: {
        paddingLeft: '64px',
        justifyContent: 'space-between',
        [theme.breakpoints.down('xs')]: {
            paddingLeft: '37px'
        },
    },
    logoContainer: {
        width: '100px',
        padding: '2px',
    },
    rightBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // gap: '16px'
    },
    cartIconButtonRootClass: {
        // padding: "0px"
    },
    cartIconButtonLabelClass: {
        position: 'relative',
    },
    cartIcon: {
        color: '#000',
        fontSize: '28px',
    },
    cartCount: {
        position: 'absolute',
        top: "-9px",
        display: "flex",
        alignItems: "center",
        height: "20px",
        padding: "0",
        width: "20px",
        justifyContent: "center",
        fontSize: "12px",
        lineHeight: "9px",
        right: "2px",
        backgroundColor: "transperant",
        color: "#2b2e8c",
        fontFamily: "Roboto",
        fontWeight: "700",
        borderRadius: "10rem"
    },
    profileIcon: {
        width: '32px',
        height: '34px',
        lineHeight: '0'
    },
    profileContainer: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "16px",
        cursor: 'pointer'
    },
    profileBoxPaper: {
        // width: (props) => {
        //     console.log('propssss', props);
        //     let val = props.anchorWidth || '250px';
        //     console.log('val', val);
        //     return val;
        // },
        cursor: 'pointer',
        width: '200px !important',
        [theme.breakpoints.down('xs')]: {
            width: '140px !important'
        },
    },
    userOption: {
        fontFamily: "Roboto",
        fontWeight: "700",
        fontSize: "12px",
        color: "#343a40",
        padding: "6px 16px",
        [theme.breakpoints.down('xs')]: {
            padding: '4px 7px',
            minHeight: '27px'
        },
    },
    userMenuItemClass: {
        display: "block",
        width: "100%",
        fontWeight: "400",
        color: "#212529",
        fontSize: ".875rem",
        [theme.breakpoints.down('xs')]: {
            padding: '4px 7px',
            minHeight: '27px'
        },
    },
    dropdownDivider: {
        height: "0",
        margin: "0.5rem 0",
        overflow: "hidden",
        borderTop: "1px solid #e9ecef",
        [theme.breakpoints.down('xs')]: {
            margin: "0.25rem 0",
        },
    }

}));

const MaterialAppBar = ({ logout }) => {
    const [showUserMenu, setShowUserMenu] = useState(false);
    const customerNameRef = useRef(null);
    const history = useHistory();
    const classes = useStyles({
        anchorWidth: customerNameRef?.current?.clientWidth ? (customerNameRef?.current?.clientWidth + 'px') : '250px'
    });
    const menuRef = useRef(null);
    const { pendingCount, customerName } = useInvestorCartDetail();

    const handleClose = () => {
        setShowUserMenu(false);
    }
    // Handle clicks outside of the menu
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && menuRef.current.contains(event.target)) {
                handleClose();
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        if (customerNameRef.current) {
            console.log('Typography component:', customerNameRef.current);
            // You can now interact with the DOM node
        }
    }, []);

    const handleProfile = () => {
        setShowUserMenu(true);
    }

    const gotoContactUs = () => {
        history.push("/contact-us");
    }

    const gotoPortFolio = () => {
        history.push("/portfolio");
    }
    const gotoResetPasscode = () => {
        history.push("/login/resetpasscode");
    }
    const handleLogout = () => {
        logout?.();
    }

    const handleCartClick = () => {
        history.push("/cart");
    }

    return (
        <AppBar classes={{
            colorPrimary: classes.appBarColorPrimaryClass
        }}>
            <Toolbar classes={{
                root: classes.toolBarRoot
            }}>
                {/* <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu">
                    <MenuIcon />
                </IconButton> */}

                <IconButton
                    classes={{
                        root: classes.logoContainer
                    }}
                >
                    <Image image="nav/moamc-mf-logo-new.png" alt="logo" />
                </IconButton>

                <Box className={`${classes.rightBox}`}>
                    <IconButton classes={{
                        label: classes.cartIconButtonLabelClass,
                        root: classes.cartIconButtonRootClass
                    }}
                        onClick={handleCartClick}
                    >
                        {/* <i className={`mdi mdi-cart-outline ${classes.cartIcon}`}></i> */}
                        <Image image="nav/cart.svg" class="cartIcon" alt="cart-icon" />
                        <span class={`badge badge-up badge-pill ${classes.cartCount}`}>{pendingCount}</span>
                    </IconButton>

                    <Box className={`${classes.profileContainer}`} onClick={handleProfile} ref={customerNameRef}>
                        <Icon classes={{
                            root: classes.profileIcon
                        }}>
                            <Image image="nav/profile-icon.png" alt="image" />
                        </Icon>
                        <div className={`${classes.investorNameContainer}`}>
                            <Typography variant="h6" className={classes.title} >
                                {customerName}
                            </Typography>
                        </div>
                    </Box>

                    {
                        customerNameRef.current
                            ?
                            <Menu
                                id="investor-menu-appbar"
                                open={showUserMenu}
                                keepMounted
                                anchorEl={customerNameRef.current}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: -16,
                                }}
                                // className={`${classes.profileBox}`}
                                classes={{
                                    paper: `${classes.profileBoxPaper}`
                                }}
                                getContentAnchorEl={null}
                                ref={menuRef}
                            >
                                <Box>
                                    <Typography className={`${classes.userOption}`}>User Options</Typography>
                                    <MenuItem className={`${classes.userMenuItemClass}`} onClick={gotoContactUs}>
                                        <span>Contact Us</span>
                                    </MenuItem>
                                    <MenuItem className={`${classes.userMenuItemClass}`} onClick={gotoPortFolio}>
                                        <span>My Portfolio</span>
                                        <span className="p-0">
                                            <i className="mdi mdi-account-outline ml-1"></i>
                                        </span>
                                    </MenuItem>
                                    <MenuItem className={`${classes.userMenuItemClass}`} onClick={gotoResetPasscode}>
                                        <span>Reset Passcode</span>
                                        <span className="p-0">
                                            <i className="mdi mdi-lock-reset ml-1"></i>
                                        </span>
                                    </MenuItem>
                                    <div role="separator" className={`${classes.dropdownDivider}`}></div>

                                    <Typography className={`${classes.userOption}`}>Actions</Typography>
                                    <MenuItem className={`${classes.userMenuItemClass}`} onClick={handleLogout}>
                                        <span>Log Out</span>
                                        <i className="mdi mdi-logout ml-1"></i>
                                    </MenuItem>

                                </Box>
                            </Menu>
                            :
                            null
                    }

                </Box>
            </Toolbar>
        </AppBar >
    )
}

export default MaterialAppBar